div {
	/* Position */
	position: relative;
	z-index: 1;
}

.triggerWrapper {
	height: 38px;
}

menu {
	/* Flex */
	display: flex;
	flex-direction: column;

	/* Position */
	position: absolute;
	top: 42px;
	right: 0px;
	

	/* Spacing */
	padding: 0px;
	margin: 0px;

	/* Color */
	background-color: var(--card-color);

	/* Box Sizing */
	box-sizing: border-box;

	/* Border */
	border-radius: 5px;
	border-style: solid;
	border-width: 1px;
	border-color: var(--border-color);
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

menu .menuItem:not(:last-child) {
	/* Border */
	border-style: solid;
	border-color: var(--border-color);
	border-width: 0px 0px 1px 0px;
}

.menuItem {
	/* Flex */
	display: flex;
	align-items: center;
	
	/* Spacing */
	padding: 10px 20px 10px 20px;

	/* Cursor */
	cursor: pointer;
}

.menuItem > img {
	/* Spacing */
	padding-right: 10px;

	/* Dimensions */
	height: 18px;
	width: 18px;
}

.menuItem:hover {
	background-color: #00000009;
}

p {
	margin: 0px;
	white-space: nowrap;
}